module.exports = __webpack_public_path__ + "assets/media/email_sent.504f01c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/email_sent.svg
// module id = 115
// module chunks = 0